var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_3556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6408 8.40059H18.7328L16.1568 5.76859C16.0448 5.65659 15.9048 5.60059 15.7648 5.60059H6.16078C5.85278 5.60059 5.60078 5.85259 5.60078 6.16059V8.40059H3.36078C3.05278 8.40059 2.80078 8.65259 2.80078 8.96059V21.8406C2.80078 22.1486 3.05278 22.4006 3.36078 22.4006H24.6408C24.9488 22.4006 25.2008 22.1486 25.2008 21.8406V8.96059C25.2008 8.65259 24.9488 8.40059 24.6408 8.40059ZM6.72078 6.72059H15.4848L17.1368 8.40059H6.72078V6.72059ZM24.0808 21.2806H3.92078V9.52059H24.0808V21.2806Z",
    fill: "#3361CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.521 -260.4V211.12H-195.999V-260.4H303.521ZM305.761 -262.64H-198.239V213.36H305.761V-262.64Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4702 14.6396H9.89424L9.16464 13.6182L8.44272 14.6396H7.8744L8.8728 13.2688L7.92816 11.9516H8.49264L9.18 12.9078L9.85968 11.9516H10.4011L9.46032 13.2496L10.4702 14.6396Z",
    fill: "#3361CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1499 14.6396H18.5739L17.8443 13.6182L17.1224 14.6396H16.5541L17.5525 13.2688L16.6079 11.9516H17.1723L17.8597 12.9078L18.5394 11.9516H19.0808L18.14 13.2496L19.1499 14.6396Z",
    fill: "#3361CF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1201,
    y1: 18.8,
    x2: 16.6401,
    y2: 18.8,
    stroke: "#3361CF",
    strokeWidth: 0.48
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_3556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no_data_available.469a52c2f22ca3d98c832e3067eb56c1.svg";
export { ForwardRef as ReactComponent };